import { trackByIndex } from 'src/app/shared/utils/track-by.util';
import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ExposureTaskDistribution } from 'src/app/models/exposureBySeg.model';
import { ErrorConstants } from 'src/app/shared/constants/error.constants';

@Component({
  standalone: false,
  selector: 'app-task-distribution',
  templateUrl: './task-distribution.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./task-distribution.component.scss']
})
export class TaskDistributionComponent implements OnInit {
  @Input() exposureTaskDistributions: ExposureTaskDistribution[];
  @Input() loadingExposureTaskDistribution: boolean = true;
  
  errorMessage: string = "";

  constructor(
  ) {
    this.errorMessage = ErrorConstants.errorMessage;
  }

  ngOnInit(): void {
  }

  public trackByIndex = trackByIndex;
}
